import styled from "styled-components/macro";
export const ContainerBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #000000;
  height: 49px;

  div {
    background: #111111;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 52.4px;
    height: 49px;
    cursor: pointer;
  }
  @media (min-width: 992px) {
    display: flex;
    justify-content: center;
    align-items: end;
    flex-direction: column;
    background-color: #000000;
    height: 72px;
    padding-right: 7.7rem;
    div {
      width: 77px;
      height: 72px;
    }
  }
`;
export const SvgArrow = styled.svg`
  cursor: pointer;
  width: 17px;
  height: 10px;
  animation-name: moveUp;
  -webkit-animation-name: moveUp;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
  animation-duration: 1s easy-in-out;
  -webkit-animation-duration: 1s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  @keyframes moveUp {
    0% {
      transform: translateY(10px);
    }

    100% {
      transform: translateY(-10px);
    }
  }
  @media (min-width: 992px) {
    width: 25px;
    height: 15px;
  }
`;
export const ContainerData = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 20px;
  justify-content: space-between;
  align-items: center;

  background-color: #232323;
  padding-top: 1rem;

  @media (min-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    align-items: center;
    justify-content: center;
    padding: 2rem 0rem 0.2rem 12.2rem;
  }
`;

export const ContainerEmail = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.5rem;
  margin-bottom: 1rem;
  @media (min-width: 992px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
    padding-top: ${({ hr }) => (hr ? "0" : "1.5rem")};
    margin-bottom: ${({ hr }) => (hr ? "0" : "1rem")};
  }
`;
export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: ${({ dir }) => (dir ? "row" : "column")};
  justify-content: space-between;
  align-items: start;
  margin-top: 1rem;
  margin-bottom: 0;
  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Text = styled.a`
  z-index: 999;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 300;
  font-size: ${({ dir }) => (dir ? "14px" : "12px")};
  line-height: 138%;
  text-decoration: none;
  cursor: pointer;
  text-align: center;
  color: #ffffff;
  margin-bottom: ${({ dir }) => (dir ? "0" : "0.5rem")};

  @media (min-width: 992px) {
    font-size: ${({ mL }) => (mL ? "14px" : "16px")};
    line-height: 138%;
    margin: 0.5rem;
    margin-right: ${({ mL }) => (mL ? "1.5rem" : "4rem")};
  }
`;
export const Hr = styled.hr`
  border: none;
  height: 1px;
  background: #333;
  width: 19.6rem;
  @media (min-width: 992px) {
    width: 483px;
    margin-left: 0.5rem;
  }
`;
export const ContainerAddress = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (min-width: 992px) {
    justify-content: flex-start;
    align-items: start;
    padding: 0.4rem 0 0 1.5rem;
  }
`;
export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  p {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 300;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    line-height: 10px;
  }
  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: ${({ maps }) => (maps ? "1.5rem" : "0")};

    p {
      text-align: start;
      font-size: 14px;
      line-height: 10px;
      margin-left: 1.3rem;
    }
  }
`;
export const Svg = styled.svg`
  cursor: pointer;
  margin-bottom: 0.5rem;

  transform: ${({ scroll }) =>
    scroll > 4000 ? "translateX(0)" : "translateX(-200px)"};
  transition: ${({ phono, smartPhono }) =>
    phono
      ? "transform 0.7s ease-in-out"
      : smartPhono
      ? "transform 1s ease-in-out"
      : "transform 0.5s ease-in-out"};
  @media (min-width: 992px) {
    margin-bottom: 0;
    transform: none;
    opacity: ${({ scroll }) => (scroll > 3200 ? "1" : "0")};
    transition: ${({ phono, smartPhono }) =>
      phono
        ? "opacity 3s ease-in-out"
        : smartPhono
        ? "opacity 5s ease-in-out"
        : "opacity 1s ease-in-out"};
  }
`;
export const Path = styled.path`
  cursor: pointer;
`;
export const ContainerCrombie = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 300;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    line-height: 10px;
    margin: 0 0 0.7rem 0;
  }
  @media (min-width: 992px) {
    justify-content: flex-start;
    align-items: start;
    p {
      font-size: 10px;
    }
  }
`;
export const TextBotton = styled.p`
  @media (min-width: 992px) {
    padding-top: ${({ smartPhone }) => (smartPhone ? "2.5rem" : "1rem")};
  }
`;
export const A = styled.a`
  font-family: "Rubik";
  font-style: normal;
  font-weight: 300;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  line-height: 10px;
  text-decoration: none;
  cursor: pointer;
  @media (min-width: 992px) {
    font-size: 10px;
  }
`;
export const ContainerScroll = styled.div`
  display: flex;
  z-index: 999;
  flex-direction: row;
  justify-content: space-between;
  width: 19.6rem;
  @media (min-width: 992px) {
    width: 483px;
  }
`;
